var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.66 108.41c41.29 0 63.88-34.21 63.88-63.88 0-1 0-1.94-.07-2.9A45.53 45.53 0 0 0 118.67 30a44.91 44.91 0 0 1-12.89 3.54 22.57 22.57 0 0 0 9.87-12.42 45.12 45.12 0 0 1-14.25 5.45 22.46 22.46 0 0 0-38.85 15.35 22.14 22.14 0 0 0 .59 5.08 63.73 63.73 0 0 1-46.28-23.42 22.48 22.48 0 0 0 7 30 22.44 22.44 0 0 1-10.17-2.81V51a22.47 22.47 0 0 0 18 22 22.3 22.3 0 0 1-10.14.38A22.46 22.46 0 0 0 42.48 89a45 45 0 0 1-27.88 9.63 45.25 45.25 0 0 1-5.36-.31 63.57 63.57 0 0 0 34.42 10.09",
    fill: "#1da1f2"
  })));
};
export default SvgTwitter;